import React from "react";
import LogoHeaderLight from "./logo-white.svg";
import LogoAlt from "./logo-alt.svg";
import PropTypes from "prop-types";

export const HALogo = ({ altLogo = false, ...props }) => (
  <img src={altLogo ? LogoAlt : LogoHeaderLight} alt="HireArt" {...props} />
);
HALogo.propTypes = {
  altLogo: PropTypes.bool,
};

